import React, { useContext } from 'react';
import { Box, TableCell, TableHead as MuiTableHead, TableRow, Tooltip } from '@material-ui/core';
import { HelpOutline } from '@material-ui/icons';

import { headers } from './headers';

import { useStyles } from './styles';
import { ManageOrderContext } from 'contexts/manageOrder';

export const TableHead = () => {
  const styles = useStyles();
  const { daysUntilDeadlineLabel } = useContext(ManageOrderContext);

  const handleTooltipText = (header: string) => {
    if (header === 'Desconto No Show') {
      return 'É aplicado quando uma entrega não é realizada no dia agendado';
    }
    if (header === 'Desconto Alteração Agenda Tardia') {
      return daysUntilDeadlineLabel
        ? `Um desconto é aplicado quando a entrega é alterada em ${daysUntilDeadlineLabel} a data confirmada anteriormente`
        : 'Um desconto é aplicado quando a entrega é alterada dentro de um prazo pré-definido, em relação a data confirmada anteriormente';
    } else {
      return '';
    }
  };

  const displayTooltip = (header: string) => {
    if (header === 'Desconto No Show' || header === 'Desconto Alteração Agenda Tardia') {
      return true;
    }
    return false;
  };

  return (
    <MuiTableHead>
      <TableRow className={styles.tableHeadRow}>
        {headers.map((header, i) => (
          <Tooltip key={i} title={handleTooltipText(header)}>
            <TableCell className={styles.tableHeadCell}>
              <Box>
                {header} {displayTooltip(header) && <HelpOutline style={{ fontSize: '16px' }} />}
              </Box>
            </TableCell>
          </Tooltip>
        ))}
      </TableRow>
    </MuiTableHead>
  );
};
